import React, { PureComponent, ReactNode } from 'react';
import {
  CmsBrowseResultsSummary,
  createBrowseResultsSummaryViewModel,
} from 'js/model/view/browse-page/browse-results-summary';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';
import { Context as GeneralContext } from 'js/components/LocaleWrapper';
import { urlContext as UrlContext } from 'js/components/url';
import styles from './ResultsSummary.module.css';

interface Props {
  cms: CmsBrowseResultsSummary;
  resultCount: number;
  specification: VenueListingSpecificationOutput;
}

export class ResultsSummary extends PureComponent<Props> {
  public render(): ReactNode {
    return (
      <GeneralContext.Consumer>
        {({ pageData }) => (
          <UrlContext.Consumer>
            {({ query }) => {
              const resultsSummary = createBrowseResultsSummaryViewModel(
                this.props.cms,
                this.props.resultCount,
                this.props.specification,
                Boolean(pageData.pageParameters?.brands),
                query.titleoverride
              );
              return (
                <h1 className={styles.resultsSummary}>
                  {resultsSummary !== undefined && resultsSummary}
                </h1>
              );
            }}
          </UrlContext.Consumer>
        )}
      </GeneralContext.Consumer>
    );
  }
}
